import React from 'react';

export const Field = ({ label, children, hint }) => (
  <div>
    {label && (
      <label className="mb-1.5 block text-[12.5px] font-medium text-[#0B2545]">
        {label}
      </label>
    )}
    {children}
    {hint && <div className="mt-1 text-[11.5px] text-[#0B2545]/55">{hint}</div>}
  </div>
);

export const TextInput = ({ value, onChange, ...rest }) => (
  <input
    value={value ?? ''}
    onChange={(e) => onChange(e.target.value)}
    className="w-full rounded-md border border-[#E6DDC8] bg-white px-3 py-2 text-[14px] text-[#0B2545] outline-none focus:border-[#C9A86A]"
    {...rest}
  />
);

export const TextArea = ({ value, onChange, rows = 4, ...rest }) => (
  <textarea
    rows={rows}
    value={value ?? ''}
    onChange={(e) => onChange(e.target.value)}
    className="w-full resize-y rounded-md border border-[#E6DDC8] bg-white px-3 py-2 text-[14px] text-[#0B2545] outline-none focus:border-[#C9A86A]"
    {...rest}
  />
);

export const NumberInput = ({ value, onChange, ...rest }) => (
  <input
    type="number"
    value={value ?? 0}
    onChange={(e) => onChange(Number(e.target.value))}
    className="w-full rounded-md border border-[#E6DDC8] bg-white px-3 py-2 text-[14px] text-[#0B2545] outline-none focus:border-[#C9A86A]"
    {...rest}
  />
);

export const Select = ({ value, onChange, options, ...rest }) => (
  <select
    value={value ?? ''}
    onChange={(e) => onChange(e.target.value)}
    className="w-full rounded-md border border-[#E6DDC8] bg-white px-3 py-2 text-[14px] text-[#0B2545] outline-none focus:border-[#C9A86A]"
    {...rest}
  >
    {options.map((o) => (
      <option key={o.value} value={o.value}>
        {o.label}
      </option>
    ))}
  </select>
);

export const Toggle = ({ checked, onChange, label }) => (
  <label className="inline-flex cursor-pointer items-center gap-2">
    <span
      className={`relative inline-flex h-5 w-9 items-center rounded-full transition ${
        checked ? 'bg-[#C9A86A]' : 'bg-[#E6DDC8]'
      }`}
      onClick={() => onChange(!checked)}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition ${
          checked ? 'translate-x-4' : 'translate-x-0.5'
        }`}
      />
    </span>
    {label && <span className="text-[13px] text-[#0B2545]">{label}</span>}
  </label>
);

export const Button = ({ variant = 'primary', className = '', children, ...rest }) => {
  const styles = {
    primary:
      'bg-[#0B2545] text-white hover:bg-[#08203a] disabled:opacity-60',
    gold:
      'bg-[#C9A86A] text-white hover:bg-[#b8975c] disabled:opacity-60',
    outline:
      'border border-[#E6DDC8] bg-white text-[#0B2545] hover:bg-[#F6F2EA] disabled:opacity-60',
    danger:
      'border border-red-200 bg-white text-red-600 hover:bg-red-50 disabled:opacity-60'
  };
  return (
    <button
      className={`inline-flex items-center gap-2 rounded-md px-4 py-2 text-[13.5px] font-medium transition ${styles[variant]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
};
